import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useToast } from "../../services/utils";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid,
} from "@mui/material";
import { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FlexBetween from "../../components/FlexBetween";
import ResultStorageParameters from "../../components/Rules/ResultStorageParameters";
import RunParameters from "../../components/Rules/RunParameters";
import ScoringConfigOverrideAccordion from "../../components/Scoring/ScoringConfigOverrideAccordion";
import {
  getDefaultRunParameters,
  getQueryParams,
} from "../../config/runParametersConfig";
import { useResourceContext } from "../../contexts/ResourceContext";
import useFetchFileProcessing from "../../hooks/useFetchFileProcessing";
import useFetchResourceByResourceId from "../../hooks/useFetchResourceByResourceId";
import { apiType, sqlDatabaseType } from "../../services/constants";
import {
  backgroundResourceValidation,
  getResourceUsedVariables,
  ResourceValidation,
  validateEngineRequest,
} from "../../services/resourcesService";
import ValidateResourceDataTab from "./ValidateResourceDataTab";
//add for varibles
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import Loader from "../../components/Molecules/Loader/Loader";
import useFetchAllConnectionKey from "../../hooks/useFetchAllConnectionKey";
import FilterRules from "../../components/Resource/FilterRules";
import InlineVariables from "./InlineVariables";
import CustomAccordian from "../../components/Molecules/Accordian/CustomAccordion";
import useFetchResourceColumnsById from "../../hooks/useFetchResourceColumnsById";
import AddMultipleGridList from "../../components/AddMultipleGridList";
import { useBreadCrumbContext } from "../../contexts/BreadCrumbContext";
import { useRuleResourceContext } from "../../contexts/RuleResourceContext";
import { useSystemContext } from "../../contexts/TagAndSystemProvider";
import useFetchAllSystem from "../../hooks/useFetchAllSystem";
import { filterRulesNameSchema, filterRulesSqlSchema } from "../../schemas";
import useFetchAllResourcesWithoutDomain from "../../hooks/useFetchAllResourcesWithoutDomain";
import { executionNameSchema } from "../../schemas";
import ExecutionName from "../../components/Molecules/Rule/ExecutionName";
import useFetchLinkedServices from "../../hooks/useFetchLinkedServices";
import { getDifferentValues } from "../../services/utils/processRuleExecutionResourcesData";
import { compareFilterRules } from "../../services/utils/compareFilterRules";
import { IconBtnEditBase } from "../../common/utils/icons";
import { extractConnectionKeyIds } from "../../utils/connectionKeyUtils";
import useFetchResourcesByMultipleIds from "../../hooks/useFetchResourcesByMultipleIds";
import ViewPayloadDialog from "../../components/Dialogs/ViewPayloadDialog";
import { useAuth } from "../../contexts/AuthContext";
import useFetchResourceColumnsByMultipleIds from "../../hooks/useFetchResourceColumnsByMultipleIds";
import useFetchAllConnectionKeyWithoutId from "../../hooks/useFetchAllConnectionKeyWithoutId";
import useFetchValidationScoringConfig from "../../hooks/useFetchValidationScoringConfig";
import { getOptionalConfig } from "../../config/runtimeConfig";

interface FilterFormData {
  filter_rules: any[];
}

const ValidateResource = () => {
  const { setCurrentBreadcrumbPage } = useBreadCrumbContext();
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    setResourceColumnData,
    resourceColumnData,
    refetchData,
    errors,
    setErrors,
    setLinkedServicesData,
    setAllResourcesAdditionalData,
  } = useResourceContext();
  const {
    isResourceEdit,
    globalVariables,
    // setGlobalVariables,
    allResourcesData,
    setAllResourcesData,
    setFileProcessingData,
    setFetchedAllConnectionKeys,
    setResourceColumnsData,
    // New variable management
    validateResourceVariable,
    initializeVariables,
    startEditingVariables,
    saveVariableChanges,
    cancelVariableChanges,
    updateEditingVariable,
    updateUsedVariableNames,
    getFilteredVariables,
    hasAnyVariables,
    hasVariableChanges,
    toggleVariableView,
    collectUsedVariables,
  } = useRuleResourceContext();
  const { showToast } = useToast();
  const [isEditFilters, setIsEditFilters] = useState(false);

  const [filterFormData, setFilterFormData] = useState<
    FilterFormData | undefined
  >(undefined);
  const [intialFilterFormData, setIntialFilterFormData] = useState<
    FilterFormData | undefined
  >(undefined);
  const [originalFilterRulesData, setOriginalFilterRulesData] = useState<
    FilterFormData | undefined
  >(undefined);
  const [tempFilterFormData, setTempFilterFormData] = useState<any>({});
  const [hasFilterChanges, setHasFilterChanges] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [loadingCounter, setLoadingCounter] = useState<number>(0);
  const [isBackdropLoading, setIsBackdropLoading] = useState<boolean>(false);

  // Loading counter functions to handle multiple concurrent operations
  const incrementLoading = () => {
    setLoadingCounter((prev) => {
      const newCount = prev + 1;
      if (newCount === 1) {
        setIsLoading(true);
      }
      return newCount;
    });
  };

  const decrementLoading = () => {
    setLoadingCounter((prev) => {
      const newCount = Math.max(0, prev - 1);
      if (newCount === 0) {
        setIsLoading(false);
      }
      return newCount;
    });
  };

  // Create loading manager object to pass down
  const loadingManager = {
    incrementLoading,
    decrementLoading,
    // Keep original setIsLoading for backward compatibility with other hooks
    setIsLoading,
  };
  const [resultStorageParameters, setResultStorageParameters] = useState<any>({
    linked_service_id: getOptionalConfig("REACT_APP_OUTPUT_STORAGE_LINKED_SERVICE_ID"),
    linked_service_code:
      getOptionalConfig("REACT_APP_OUTPUT_STORAGE_LINKED_SERVICE_CODE"),
    connection_key_id: getOptionalConfig("REACT_APP_OUTPUT_STORAGE_CONNECTION_KEY"),
    file_path: getOptionalConfig("REACT_APP_OUTPUT_FILES_BASE_PATH"),
  });
  const [originalResultStorageParameters, setOriginalResultStorageParameters] =
    useState<any>({
      linked_service_id: getOptionalConfig("REACT_APP_OUTPUT_STORAGE_LINKED_SERVICE_ID"),
      linked_service_code:
        getOptionalConfig("REACT_APP_OUTPUT_STORAGE_LINKED_SERVICE_CODE"),
      connection_key_id: getOptionalConfig("REACT_APP_OUTPUT_STORAGE_CONNECTION_KEY"),
      file_path: getOptionalConfig("REACT_APP_OUTPUT_FILES_BASE_PATH"),
    });

  const [runParameters, setRunParameters] = useState<any>(
    getDefaultRunParameters("validateResource")
  );
  const [originalRunParameters, setOriginalRunParameters] = useState<any>(
    getDefaultRunParameters("validateResource")
  );
  const [scoreConfigOverride, setScoreConfigOverride] = useState<Record<
    string,
    any
  > | null>(null);

  // Resource-level validation scoring config (overrides over system defaults).
  // Passed to ScoringConfigOverrideAccordion as `currentConfig` so the accordion
  // seeds its initial values from the resource's saved config rather than the
  // system defaults. When the resource has no override, the API returns null/
  // undefined and the accordion falls back to defaults.
  const [validationScoringConfig] = useFetchValidationScoringConfig({
    setIsLoading,
    resourceId: id ? Number(id) : null,
  });

  const [severityColumnNames, setSeverityColumnNames] = useState<any>({
    low: null,
    medium: null,
    high: null,
  });
  const [originalSeverityColumnNames, setOriginalSeverityColumnNames] =
    useState<any>({
      low: null,
      medium: null,
      high: null,
    });
  const [isEditResource, setIsEditResource] = useState(false);
  const [expandedAccordion, setExpandedAccordion] =
    useState<any>("resource-data");
  const [validationMessage, setValidationMessage] = useState<any[]>([]);
  const [checkValidation, setCheckValidation] = useState(false);
  const [currentResourceColumnId, setCurrentResourceColumnId] =
    useState<any>(null);

  const [validateResourcePayload, setValidateResourcePayload] =
    useState<any>(null);
  const [resourcesData, setResourcesData] = useState<any>({});
  const [originalResourcesData, setOriginalResourcesData] = useState<any>({});
  const [isReRunData, setIsReRunData] = useState<any>({
    validationID: null,
    isReRun: false,
  });
  const [executionName, setExecutionName] = useState("");
  const [executionMode, setExecutionMode] = useState(true);
  const [isPayloadDialogOpen, setIsPayloadDialogOpen] = useState(false);
  const [validationResponse, setValidationResponse] = useState<any>(null);
  const [isValidating, setIsValidating] = useState(false);

  const [fileProcessingData] = useFetchFileProcessing({ setIsLoading });
  const [linkedServices] = useFetchLinkedServices({ setIsLoading });

  // Fetch resource data first to determine which connection keys we need
  const [resourceData] = useFetchResourceByResourceId({
    currentResourceId: id,
    setIsLoading,
  });
  // Extract resource IDs from additional_resource_data to fetch the actual resource data
  const additionalResourceIds = useMemo(() => {
    if (!resourceData?.additional_properties?.additional_resource_data)
      return [];
    return resourceData.additional_properties.additional_resource_data
      .map((ar: any) => ar.resource_id)
      .filter((id: any) => id && id > 0);
  }, [resourceData]);

  // Fetch the actual resource data for additional resources
  const [additionalResourcesData] = useFetchResourcesByMultipleIds({
    resourceIds: additionalResourceIds,
    setIsLoading,
  });
  const [allResources] = useFetchAllResourcesWithoutDomain({
    setIsLoading,
    aggregation_type: "aggregated",
    //   allResourcesData?.length <= 0 &&
    //   resourcesData?.aggregation_type === "aggregated"
    //     ? "aggregated"
    //     : "flat",
  });
  // Extract base resource ID from base_resource_id field to fetch the actual resource data
  const additionalBaseResourceIds = useMemo(() => {
    // Check for single base_resource_id field under additional_properties
    const baseResourceId =
      resourceData?.additional_properties?.aggregation_properties
        ?.base_resource_id;

    if (!baseResourceId || baseResourceId <= 0) {
      return [];
    }
    return [baseResourceId];
  }, [resourceData]);
  // Fetch the actual resource data for additional base resources
  const [additionalBaseResourcesData] = useFetchResourcesByMultipleIds({
    resourceIds: additionalBaseResourceIds,
    setIsLoading,
  });

  const [fetchedConnectionKeys] = useFetchAllConnectionKeyWithoutId({
    setIsLoading,
  });

  useEffect(() => {
    if (fetchedConnectionKeys) {
      setFetchedAllConnectionKeys(fetchedConnectionKeys);
    }
  }, [fetchedConnectionKeys, setFetchedAllConnectionKeys]);

  // Extract required connection key IDs from resource data and linked services
  const requiredConnectionKeyIds = useMemo(() => {
    if (!resourceData) return [];

    // Extract connection key IDs from resource data and linked services
    const ids = extractConnectionKeyIds(
      resourceData,
      additionalResourcesData, // Use fetched additional resource data instead of raw references
      linkedServices, // Include linked services to get their connection keys too
      undefined, // outputStorageParams - not used in ValidateResource
      additionalBaseResourcesData // Use fetched additional base resource data instead of raw references
    );

    // DIRECT FIX: Ensure all connection keys from resource definition are included
    const directConnectionKeyId =
      resourceData?.additional_properties?.resource_definition?.connection_key;
    const apiConnectionKeyId =
      resourceData?.additional_properties?.resource_definition?.api_definition
        ?.connection_key;

    // Also check for other possible connection key locations
    const sqlConnectionKeyId =
      resourceData?.additional_properties?.resource_definition?.sql_definition
        ?.connection_key;
    const blobConnectionKeyId =
      resourceData?.additional_properties?.resource_definition?.blob_definition
        ?.connection_key;
    const sftpConnectionKeyId =
      resourceData?.additional_properties?.resource_definition?.sftp_definition
        ?.connection_key;
    const localConnectionKeyId =
      resourceData?.additional_properties?.resource_definition?.local_definition
        ?.connection_key;

    if (directConnectionKeyId && !ids.includes(directConnectionKeyId)) {
      ids.push(directConnectionKeyId);
    }

    if (apiConnectionKeyId && !ids.includes(apiConnectionKeyId)) {
      ids.push(apiConnectionKeyId);
    }

    // DYNAMIC FIX: Force include any connection key IDs that are referenced in the resource
    const allReferencedConnectionKeys = [
      directConnectionKeyId,
      apiConnectionKeyId,
      sqlConnectionKeyId,
      blobConnectionKeyId,
      sftpConnectionKeyId,
      localConnectionKeyId,
      // Add any other connection key references we might find
    ].filter((id) => id && !ids.includes(id));

    allReferencedConnectionKeys.forEach((id) => {
      ids.push(id);
    });
    return ids;
  }, [
    resourceData,
    linkedServices,
    additionalResourcesData,
    additionalBaseResourcesData,
  ]);

  // // Fetch only the specific connection keys needed (optimized API call)
  // const [finalConnectionKeys] = useFetchAllConnectionKey({
  //   connectionKeyIds: requiredConnectionKeyIds,
  //   setIsLoading,
  // });

  // Extract resource column IDs from main resource and additional resources
  const resourceColumnIds = useMemo(() => {
    const colIds: number[] = [];

    // Add main resource column ID
    if (resourceData?.additional_properties?.resource_column_details_id) {
      colIds.push(
        resourceData.additional_properties.resource_column_details_id
      );
    }
    // Add additional resource column IDs
    const additionalResources =
      resourceData?.additional_properties?.additional_resource_data;
    if (additionalResources && Array.isArray(additionalResources)) {
      additionalResources.forEach((addRes: any) => {
        const addColId = allResources?.find(
          (res1: { id: number }) => res1.id === addRes.resource_id
        )?.additional_properties?.resource_column_details_id;
        if (addColId && !colIds.includes(addColId)) {
          colIds.push(addColId);
        }
      });
    }
    return colIds;
  }, [resourceData, allResources]);

  // Fetch resource columns for all resources (main + additional)
  const [resourceColumns] = useFetchResourceColumnsByMultipleIds({
    resourceColIds: resourceColumnIds,
    setIsLoading,
  });

  // Get the setter function from context (following linkedServicesData pattern)
  const { setAllSystemData } = useSystemContext();
  // Fetch system data directly in this component (following linkedServicesData pattern)
  const [systemData] = useFetchAllSystem({
    setIsLoading,
  });
  // Update context state when system data is fetched (following linkedServicesData pattern)
  useEffect(() => {
    if (systemData && Array.isArray(systemData)) {
      setAllSystemData(systemData);
    }
  }, [systemData, setAllSystemData]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const reRun = params.get("re-run");
    const validationId = params.get("validation-id");
    if (reRun && validationId) {
      setIsReRunData({
        validationID: Number(validationId),
        isReRun: true,
      });
    } else {
      setIsReRunData({
        validationID: null,
        isReRun: false,
      });
    }
  }, [location]);
  useEffect(() => {
    setFileProcessingData(fileProcessingData);
  }, [fileProcessingData]);

  useEffect(() => {
    if (linkedServices) {
      setLinkedServicesData(linkedServices);
    }
  }, [linkedServices, setLinkedServicesData]);

  // useEffect(() => {
  //   if (finalConnectionKeys) {
  //     setFetchedAllConnectionKeys(finalConnectionKeys);
  //   }
  // }, [finalConnectionKeys, setFetchedAllConnectionKeys]);

  // Log optimization results
  // Performance analytics - tracks connection key fetch optimization
  // useEffect(() => {
  //   if (
  //     finalConnectionKeys &&
  //     resourceData &&
  //     requiredConnectionKeyIds.length > 0
  //   ) {
  //     const totalKeys = 124; // Approximate total connection keys in system
  //     const fetchedKeys = finalConnectionKeys.length;
  //     const savedKeys = totalKeys - fetchedKeys;
  //     const savingsPercentage = ((savedKeys / totalKeys) * 100).toFixed(1);
  //     // TODO: Could be used for performance monitoring/analytics in the future
  //   }
  // }, [finalConnectionKeys, resourceData, requiredConnectionKeyIds]);

  const [resourceColumn] = useFetchResourceColumnsById({
    resourceColumnId: currentResourceColumnId,
    setIsLoading,
  });

  useEffect(() => {
    if (allResources) {
      setAllResourcesData(allResources);
      setAllResourcesAdditionalData(allResources);
    }
  }, [allResources, setAllResourcesData]);

  // Set resource columns data in context for column merging in LinkedServices
  useEffect(() => {
    if (resourceColumns?.length > 0) {
      setResourceColumnsData(resourceColumns);
    }
  }, [resourceColumns, setResourceColumnsData]);

  useEffect(() => {
    if (resourceData && fetchedConnectionKeys) {
      // const resourceVariables =
      //   resourceData?.additional_properties?.inline_variables;
      // setGlobalVariables({
      //   ...globalVariables,
      //   ...resourceVariables,
      // });
      const connectionKeyDetail = fetchedConnectionKeys?.find(
        (option: { id: any }) =>
          option.id ===
          resourceData?.additional_properties?.resource_definition
            ?.api_definition?.connection_key
      );
      let updatedResourceData: any;
      if (
        resourceData.linked_service_id &&
        resourceData?.additional_properties?.resource_definition?.type
      ) {
        let updatedResourceDefinition =
          resourceData?.additional_properties?.resource_definition?.[
            `${resourceData?.additional_properties?.resource_definition?.type}_definition`
          ];
        if (
          sqlDatabaseType.includes(
            resourceData?.additional_properties?.resource_definition?.type
          )
        ) {
          updatedResourceDefinition =
            resourceData?.additional_properties?.resource_definition
              ?.sql_definition;
        }
        updatedResourceData = {
          ...resourceData,
          additional_properties: {
            ...resourceData.additional_properties,
            resource_definition: {
              ...resourceData.additional_properties.resource_definition,
              ...updatedResourceDefinition,
              api_definition: {
                ...resourceData?.additional_properties?.resource_definition
                  ?.api_definition,
                url: connectionKeyDetail?.api_url,
                request_timeout: 0,
              },
            },
          },
        };
      } else {
        updatedResourceData = resourceData;
      }
      setResourcesData(updatedResourceData);
      setOriginalResourcesData(JSON.parse(JSON.stringify(updatedResourceData)));
      const filter_rules = updatedResourceData?.additional_properties
        ?.filter_rules
        ? updatedResourceData?.additional_properties?.filter_rules.map(
            (rule: any, index: number) => ({
              ...rule,
              id: index,
            })
          )
        : [];
      setFilterFormData({
        ...updatedResourceData?.additional_properties,
        filter_rules: filter_rules,
      });
      setOriginalFilterRulesData({
        ...updatedResourceData?.additional_properties,
        filter_rules: filter_rules,
      });
      setTempFilterFormData({
        ...updatedResourceData?.additional_properties,
        filter_rules: filter_rules,
      });
      setIntialFilterFormData(
        JSON.parse(
          JSON.stringify({
            ...updatedResourceData?.additional_properties,
            filter_rules: filter_rules,
          })
        )
      );
      const inline_variables =
        updatedResourceData?.additional_properties?.inline_variables || {};

      // Initialize variables using the new system
      initializeVariables(inline_variables, []);

      setCurrentResourceColumnId(
        updatedResourceData?.additional_properties?.resource_column_details_id
      );
    }
    setCurrentBreadcrumbPage({
      name: resourceData?.resource_name,
      id: resourceData?.id,
    });
    setExecutionName(resourceData?.resource_name);
    return () => {
      setCurrentBreadcrumbPage({ name: "", id: null });
    };
  }, [resourceData]);

  useEffect(() => {
    const fetchUsedVariables = async () => {
      if (!resourceData || Object.keys(resourceData).length === 0) return;

      const payload = {
        resource_data: {
          resource_id: resourceData.id,
        },
      };

      try {
        const usedVariables = await getResourceUsedVariables(payload);

        const usedVar: string[] = Array.from(
          collectUsedVariables(usedVariables)
        );

        // Update used variables using the new system
        updateUsedVariableNames(usedVar);
      } catch (error) {
        console.error("Error fetching used variables:", error);
      }
    };

    fetchUsedVariables();
  }, [resourceData]);

  useEffect(() => {
    if (resourceColumn && Object.keys(resourceColumn)?.length) {
      setResourceColumnData(resourceColumn);
    }
  }, [resourceColumn]);

  // Initialize original parameter values on component mount
  // This captures the baseline state for differential comparison
  useEffect(() => {
    // Set original values as deep copies to prevent reference issues
    setOriginalResultStorageParameters(
      JSON.parse(JSON.stringify(resultStorageParameters))
    );
    setOriginalRunParameters(JSON.parse(JSON.stringify(runParameters)));
    setOriginalSeverityColumnNames(
      JSON.parse(JSON.stringify(severityColumnNames))
    );
  }, []); // Empty dependency array - run only once on mount

  const getFilePreProcessing = (id: string | number | undefined) => {
    const filePreProcessing = fileProcessingData?.find(
      (file: { id: string | number | null | undefined }) => file.id === id
    );
    return filePreProcessing
      ? filePreProcessing.file_processing_attributes
      : null;
  };

  const getResourceReqBody = (resource: any) => {
    const aggregationType = resource?.aggregation_type;
    const type = resource?.additional_properties?.resource_definition?.type;

    if (!aggregationType || (aggregationType === "flat" && !type)) {
      return null;
    }

    const additional_base_resource_data =
      resource?.additional_properties?.additional_resource_data?.length > 0
        ? processAdditionalResourceData(
            resource?.additional_properties?.additional_resource_data
          )
        : null;

    let resourceObject: any = {
      aggregation_type: aggregationType,
      resource_column_details_id:
        resource?.additional_properties?.resource_column_details_id,
      resource_name: resource?.resource_name,
      resource_id: resource?.id || null,
      linked_service_id: resource?.linked_service_id || null,
      linked_service_code: resource?.linked_service_code || null,
      file_processing_id: resource?.file_processing_id,
      additional_base_resource_data,
    };

    // FLAT resources: add definition and API-related info
    if (aggregationType === "flat") {
      const {
        connection_key,
        container_name,
        resource_path,
        file_name,
        column_delimiter,
        sql_query,
        use_multi_thread_reader,
        column_name_to_partition_on_sql_query,
        excel_sheet_name,
        use_parquet_export,
        parquet_export_definition,
      } = getResourceDefinition(resource, type);

      const {
        user_name,
        password,
        bearer_token,
        api_key,
        oauth_client_id,
        oauth_client_secret,
        oauth_url,
        method,
        content_type,
        body,
        query_params,
        url_params,
        url,
        request_timeout,
      } = getApiDefinition(resource);

      const file_pre_processing =
        sqlDatabaseType.includes(type) || apiType.includes(type)
          ? null
          : getFilePreProcessing(resource?.file_processing_id);

      const api_request = apiType.includes(type)
        ? {
            user_name,
            password,
            bearer_token,
            api_key,
            oauth_client_id,
            oauth_client_secret,
            oauth_url,
            method,
            content_type,
            body,
            query_params,
            url_params,
            url,
            request_timeout,
          }
        : null;

      resourceObject = {
        ...resourceObject,
        connection_key,
        sql_query,
        container_name,
        resource_path,
        file_name,
        column_delimiter,
        file_pre_processing,
        api_request,
        use_multi_thread_reader,
        column_name_to_partition_on_sql_query,
        excel_sheet_name,
        use_parquet_export,
        parquet_export_definition,
      };
    }

    // AGGREGATED resources: include aggregation props and recurse
    if (aggregationType === "aggregated") {
      const aggregation_properties = {
        base_resource_id:
          resource?.additional_properties?.aggregation_properties
            ?.base_resource_id,
        base_resource_code:
          resource?.additional_properties?.aggregation_properties
            ?.base_resource_code,
        aggregation_query:
          resource?.additional_properties?.aggregation_properties
            ?.aggregation_query,
        base_resource_columns:
          resource?.additional_properties?.aggregation_properties
            ?.base_resource_columns,
        base_resource_validation:
          resource?.additional_properties?.aggregation_properties
            ?.base_resource_validation,
      };

      resourceObject = {
        ...resourceObject,
        aggregation_properties,
        aggregation_base_resource_data: getResourceReqBody(
          resource?.additional_properties?.aggregation_properties
        ),
      };
    }

    // Remove null/undefined values
    resourceObject = Object.fromEntries(
      Object.entries(resourceObject).filter(
        ([_, v]) => v !== null && v !== undefined
      )
    );

    return Object.keys(resourceObject).length ? resourceObject : null;
  };

  const checkOutputStorageParamsNull = (
    output_storage_params: { [s: string]: unknown } | ArrayLike<unknown>
  ) => {
    return Object.values(output_storage_params).some((value) => value === null);
  };
  const getApiDefinition = (resource: any) => {
    let user_name =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.user_name || null;
    let password =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.password || null;
    let bearer_token =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.bearer_token || null;
    let api_key =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.api_key || null;
    let oauth_client_id =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.oauth_client_id || null;
    let oauth_client_secret =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.oauth_client_secret || null;
    let oauth_url =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.oauth_url || null;
    let method =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.method || "get";
    let content_type =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.content_type || "application/json";
    let body =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.body || null;
    let query_params =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.query_params || null;
    let url_params =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.url_params || null;
    let url =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.url || null;
    let request_timeout =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.request_timeout || 0;
    return {
      user_name,
      password,
      bearer_token,
      api_key,
      oauth_client_id,
      oauth_client_secret,
      oauth_url,
      method,
      content_type,
      body,
      query_params,
      url_params,
      url,
      request_timeout,
    };
  };
  const getResourceDefinition = (resource: any, type: string) => {
    let connection_key = null;
    let container_name = null;
    let resource_path = null;
    let file_name = null;
    let column_delimiter = null;
    let sql_query = null;
    let use_multi_thread_reader = false;
    let column_name_to_partition_on_sql_query = null;
    let excel_sheet_name = null;
    let use_parquet_export = false;
    let parquet_export_definition = null;
    const resDef = resource?.additional_properties?.resource_definition;
    if (type === "blob") {
      connection_key = resDef?.connection_key || null;
      container_name = resDef?.container_name || null;
      resource_path = resDef?.resource_path || null;
      file_name = resDef?.file_name || null;
      column_delimiter = resDef?.column_delimiter || null;
      excel_sheet_name = resDef?.excel_sheet_name || null;
    } else if (type === "sftp") {
      connection_key = resDef?.connection_key || null;
      resource_path = resDef?.remote_directory || null;
      file_name = resDef?.file_name || null;
      column_delimiter = resDef?.column_delimiter || null;
      excel_sheet_name = resDef?.excel_sheet_name || null;
    } else if (type === "local") {
      connection_key = resDef?.connection_key || null;
      resource_path = resDef?.resource_path || null;
      file_name = resDef?.file_name || null;
      column_delimiter = resDef?.column_delimiter || null;
      excel_sheet_name = resDef?.excel_sheet_name || null;
    } else if (sqlDatabaseType.includes(type)) {
      sql_query = resDef?.sql_query || null;
      connection_key = resDef?.connection_key || null;
      use_multi_thread_reader =
        resDef?.sql_definition?.use_multi_thread_reader || false;
      column_name_to_partition_on_sql_query =
        resDef?.sql_definition?.column_name_to_partition_on_sql_query || null;
      use_parquet_export = resDef?.sql_definition?.use_parquet_export || false;
      parquet_export_definition = use_parquet_export
        ? resDef?.sql_definition?.parquet_export_definition || null
        : null;
    } else if (apiType.includes(type)) {
      connection_key = resDef?.api_definition?.connection_key || null;
    }

    return {
      connection_key,
      container_name,
      resource_path,
      file_name,
      column_delimiter,
      sql_query,
      use_multi_thread_reader,
      column_name_to_partition_on_sql_query,
      excel_sheet_name,
      use_parquet_export,
      parquet_export_definition,
    };
  };

  const processAdditionalResourceData = (additionalResourceData: any) => {
    if (!Array.isArray(additionalResourceData)) {
      return null;
    }
    const res = additionalResourceData
      .map((resource) => getResourceReqBody(resource))
      .filter(Boolean);
    return res;
  };

  // Extracted function to build validation payload without side effects
  const buildValidationPayload = () => {
    // Build current output storage params
    let output_storage_params = {
      output_storage_linked_service_id:
        resultStorageParameters?.linked_service_id || null,
      output_storage_linked_service_code:
        resultStorageParameters?.linked_service_code || null,
      output_storage_connection_key:
        resultStorageParameters?.connection_key_id || null,
      output_storage_base_file_path: resultStorageParameters?.file_path || null,
    };

    // Build original output storage params for comparison
    let original_output_storage_params = {
      output_storage_linked_service_id:
        originalResultStorageParameters?.linked_service_id || null,
      output_storage_linked_service_code:
        originalResultStorageParameters?.linked_service_code || null,
      output_storage_connection_key:
        originalResultStorageParameters?.connection_key_id || null,
      output_storage_base_file_path:
        originalResultStorageParameters?.file_path || null,
    };

    const isOutputStorageParamsNull = checkOutputStorageParamsNull(
      output_storage_params
    );

    // Compare output storage params and only include if changed
    const differentOutputStorageParams = getDifferentValues(
      output_storage_params,
      original_output_storage_params
    );

    let severityColumnNamesPayload = {
      1: severityColumnNames.high,
      2: severityColumnNames.medium,
      3: severityColumnNames.low,
    };

    const severity_column_names: any = Object.fromEntries(
      Object.entries(severityColumnNamesPayload).filter(([_, v]) => v !== null)
    );

    let resourceObject: any = getResourceReqBody(resourcesData);
    let originalResourcesObject: any = getResourceReqBody(
      originalResourcesData
    );

    // Get only the different values between resourceObject and originalResourcesObject
    resourceObject = getDifferentValues(
      resourceObject,
      originalResourcesObject
    );

    // Get only the different inline variables
    const differentInlineVariables = getDifferentValues(
      validateResourceVariable.allVariables,
      resourceData?.additional_properties?.inline_variables
    );

    // Remove null values
    resourceObject = Object.fromEntries(
      Object.entries(resourceObject).filter(([_, v]) => v !== null)
    );

    // Compare filter rules and only include the ones that have changed
    const changedFilterRules = compareFilterRules(
      originalFilterRulesData?.filter_rules,
      filterFormData?.filter_rules
    );

    // Only include filter_rules if there are differences
    if (changedFilterRules && changedFilterRules.length > 0) {
      resourceObject.filter_rules = changedFilterRules;
    }

    // Extract only backend-expected query params (excludes FE-only fields)
    const filteredRunParameters = getQueryParams(
      "validateResource",
      runParameters
    );

    // Build current run_instance
    const current_run_instance = {
      run_id: runParameters?.run_instance?.run_id || 1,
      run_name: runParameters?.run_instance?.run_name || "Legacy",
    };

    // Build original run_instance for comparison
    const original_run_instance = {
      run_id: originalRunParameters?.run_instance?.run_id || 1,
      run_name: originalRunParameters?.run_instance?.run_name || "Legacy",
    };

    // Compare run_instance and only include if changed
    const differentRunInstance = getDifferentValues(
      current_run_instance,
      original_run_instance
    );

    // Build current execution_sub_group
    const current_execution_sub_group = {
      execution_sub_group_id:
        runParameters?.execution_sub_group?.execution_sub_group_id || 0,
      execution_sub_group_code:
        runParameters?.execution_sub_group?.execution_sub_group_code || "",
    };

    // Build original execution_sub_group for comparison
    const original_execution_sub_group = {
      execution_sub_group_id:
        originalRunParameters?.execution_sub_group?.execution_sub_group_id || 0,
      execution_sub_group_code:
        originalRunParameters?.execution_sub_group?.execution_sub_group_code ||
        "",
    };

    // Compare execution_sub_group and only include if changed
    const differentExecutionSubGroup = getDifferentValues(
      current_execution_sub_group,
      original_execution_sub_group
    );

    // Calculate current severity level
    const current_severity_level =
      runParameters?.validation_severity_level === "high"
        ? 1
        : runParameters?.validation_severity_level === "medium"
        ? 2
        : 3;

    // Calculate original severity level
    const original_severity_level =
      originalRunParameters?.validation_severity_level === "high"
        ? 1
        : originalRunParameters?.validation_severity_level === "medium"
        ? 2
        : 3;

    // Get current and original validation_execution_report_name
    const current_validation_execution_report_name =
      resultStorageParameters?.validation_execution_report_name || null;
    const original_validation_execution_report_name =
      originalResultStorageParameters?.validation_execution_report_name || null;

    // Build base payload with always-required fields
    let reqBody: any = {
      resource_data: resourceObject,
      execution_name: executionName,
      pull_latest_files: runParameters?.pull_latest_files ?? false,
      sampling_validation: runParameters?.sampling_validation ?? false,
      sample_size: runParameters?.sampling_validation
        ? parseInt(runParameters?.sample_size) || 0
        : 0,
      query_params: {
        ...filteredRunParameters,
      },
    };

    // Only include output_storage_params if not null AND has changes
    if (
      !isOutputStorageParamsNull &&
      differentOutputStorageParams !== null &&
      Object.keys(differentOutputStorageParams).length > 0
    ) {
      reqBody.output_storage_params = differentOutputStorageParams;
    }

    // Only include run_instance if it has changed
    if (differentRunInstance !== null) {
      reqBody.run_instance = differentRunInstance;
    }

    // Only include execution_sub_group if it has changed
    if (differentExecutionSubGroup !== null) {
      reqBody.execution_sub_group = differentExecutionSubGroup;
    }

    // Only include severity_level if it has changed
    if (current_severity_level !== original_severity_level) {
      reqBody.severity_level = current_severity_level;
    }

    // Only include validation_execution_report_name if it has changed
    if (
      current_validation_execution_report_name !==
      original_validation_execution_report_name
    ) {
      reqBody.validation_execution_report_name =
        current_validation_execution_report_name;
    }

    // Only include inline_variables if there are differences
    if (differentInlineVariables !== null) {
      reqBody.inline_variables = differentInlineVariables;
    }

    // Only include severity_column_names if configured and different from original
    if (Object.keys(severity_column_names).length !== 0) {
      const original_severity_column_names_payload = {
        1: originalSeverityColumnNames.high,
        2: originalSeverityColumnNames.medium,
        3: originalSeverityColumnNames.low,
      };
      const original_severity_column_names: any = Object.fromEntries(
        Object.entries(original_severity_column_names_payload).filter(
          ([_, v]) => v !== null
        )
      );

      const differentSeverityColumnNames = getDifferentValues(
        severity_column_names,
        original_severity_column_names
      );

      if (
        differentSeverityColumnNames !== null &&
        Object.keys(differentSeverityColumnNames).length > 0
      ) {
        reqBody.severity_column_names = differentSeverityColumnNames;
      }
    }

    // Attach scoring overrides only when scoring is enabled and the user has
    // actually modified values in the override accordion. Otherwise omit the
    // field so the backend uses the existing config / system defaults.
    if (runParameters?.generate_score && scoreConfigOverride) {
      reqBody.score_config_params = scoreConfigOverride;
    }

    return reqBody;
  };

  useEffect(() => {
    const validateResourceData = () => {
      setValidationMessage([]);

      const reqBody = buildValidationPayload();

      // Validate inline variables
      if (
        reqBody.inline_variables &&
        Object.keys(reqBody.inline_variables).length > 0
      ) {
        Object.keys(reqBody.inline_variables).forEach((key) => {
          if (reqBody.inline_variables[key] === "") {
            setValidationMessage((prev) => [
              ...prev,
              {
                id: `Resource Variables`,
                message: `Please enter value for ${key}`,
              },
            ]);
          }
        });
      }

      setValidateResourcePayload(reqBody);
    };
    if (checkValidation) validateResourceData();
  }, [checkValidation]);

  useEffect(() => {
    if (
      validationMessage.length === 0 &&
      validateResourcePayload &&
      !isPayloadDialogOpen
    ) {
      setIsBackdropLoading(true);
      if (executionMode) {
        backgroundResourceValidation(validateResourcePayload)
          .then(() => {
            showToast(
              "Your resource validation is in the queue. We will notify you once it's done!",
              "warn"
            );
            navigate(`/validation-execution-history`);
          })
          .catch((error) => {
            console.error(error?.response?.data?.message);
          })
          .finally(() => {
            setCheckValidation(false);
            setValidateResourcePayload(null);
            setIsBackdropLoading(false);
          });
      } else {
        ResourceValidation(validateResourcePayload)
          .then((response) => {
            if (response) {
              showToast("Resource is validated successfully!", "success");
              navigate(
                `/validation-execution-history/validate-result/${response?.id}`,
                {
                  state: {
                    response,
                    isValidateResourceResponse: true,
                  },
                }
              );
            }
          })
          .catch((error) => {
            console.error(error?.response?.data?.message);
          })
          .finally(() => {
            setCheckValidation(false);
            setValidateResourcePayload(null);
            setIsBackdropLoading(false);
          });
      }
    } else if (validationMessage.length > 0) {
      const temp = (
        <div>
          Not all fields are configured. Please check the following fields:
          {validationMessage.map((msg) => (
            <div>
              <span style={{ fontWeight: 900 }}>{msg.id}</span>-{msg.message}
            </div>
          ))}
        </div>
      );
      showToast(temp, "warning");
      setCheckValidation(false);
      return;
    }
  }, [validationMessage, validateResourcePayload]);

  const handleChangeAccordion =
    (panel: string) => (_: any, isExpanded: any) => {
      if (isResourceEdit !== "") {
        showToast("Please save changes first!!", "warning");
        return;
      }
      setExpandedAccordion(isExpanded ? panel : null);
    };

  const handleChangeVariable = (event: any) => {
    const { name, value } = event.target;

    // Update editing variable using the new system
    updateEditingVariable(name, value);
  };

  useEffect(() => {
    const formChanged =
      JSON.stringify(tempFilterFormData) !==
      JSON.stringify(intialFilterFormData);
    setHasFilterChanges(formChanged);
  }, [tempFilterFormData, intialFilterFormData]);

  useEffect(() => {
    refetchData();
  }, [id]);
  const checkFilterRuleValidation = async (
    updatedFormData: any,
    schemaType: any
  ) => {
    const getSchemaType =
      schemaType === "name" ? filterRulesNameSchema : filterRulesSqlSchema;
    for (let index = 0; index < updatedFormData.filter_rules.length; index++) {
      const element = updatedFormData.filter_rules[index];
      try {
        await getSchemaType.validate(element, { abortEarly: false });
        const updatedJsonData = { ...errors };
        const updateKey = schemaType === "name" ? "name" : "sql_query";
        if (updatedJsonData.filter_rules.length > index) {
          updatedJsonData.filter_rules[index][updateKey] = undefined;
        } else {
          updatedJsonData.filter_rules.push({ [updateKey]: undefined });
        }
        setErrors(updatedJsonData);
      } catch (validationErrors: any) {
        const updatedJsonData = { ...errors };
        const updateKey = schemaType === "name" ? "name" : "sql_query";
        if (updatedJsonData.filter_rules.length > index) {
          updatedJsonData.filter_rules[index][updateKey] =
            validationErrors.message;
        } else {
          updatedJsonData.filter_rules.push({
            [updateKey]: validationErrors.message,
          });
        }
        setErrors(updatedJsonData);
      }
    }
  };
  const handleValidateSubmit = async () => {
    try {
      await executionNameSchema.validate(
        { execution_name: executionName },
        {
          abortEarly: false,
        }
      );
      setCheckValidation(true);
    } catch (validationErrors: any) {
      const newErrors: { [key: string]: string } = {};
      validationErrors.inner.forEach(
        (error: { path: string | number; message: string }) => {
          newErrors[error.path] = error.message;
        }
      );
      setErrors((prevErrors: any) => ({
        ...prevErrors,
        ...newErrors,
      }));
    }
  };

  const handleCopyPayload = async (event: React.MouseEvent) => {
    event.stopPropagation(); // Prevent button click from triggering
    try {
      const payload = buildValidationPayload();
      const formattedPayload = JSON.stringify(payload, null, 2);
      await navigator.clipboard.writeText(formattedPayload);
      showToast("JSONcopied to clipboard!", "success");
    } catch (err) {
      console.error("Failed to copy JSON:", err);
      showToast("Failed to copy JSON to clipboard", "error");
    }
  };

  const handleValidatePayload = async (payload: any) => {
    setIsValidating(true);
    try {
      const validateReqBody = {
        target_endpoint: `/validations/validate-with-in-body-query-params`,
        method: "POST",
        body: payload,
        query_params: {},
        url_params: { id },
      };
      const response = await validateEngineRequest(validateReqBody);
      setValidationResponse(response);
      if (response?.is_valid) {
        showToast("Payload is valid!", "success");
      }
    } catch (error: any) {
      showToast(error?.response?.data?.message || "Validation failed", "error");
    } finally {
      setIsValidating(false);
    }
  };

  return (
    <>
      <Loader isLoading={isBackdropLoading} />
      <Loader isLoading={isLoading} />

      {isReRunData?.isReRun && (
        <Box className="re-run-header">
          <h2>Re-Run</h2>
        </Box>
      )}

      <div
        className="accordion-panel"
        style={{ marginBottom: "0", marginTop: "12px" }}
      >
        <Box>
          <ExecutionName
            handleChangeAccordion={handleChangeAccordion}
            errors={errors}
            setErrors={setErrors}
            executionName={executionName}
            setExecutionName={setExecutionName}
            executionMode={executionMode}
            setExecutionMode={setExecutionMode}
            runParameters={runParameters}
            setRunParameters={setRunParameters}
            setIsLoading={setIsLoading}
            isReRun={isReRunData?.isReRun || false}
          />

          <ValidateResourceDataTab
            resourcesData={resourcesData}
            setResourcesData={setResourcesData}
            setOriginalResourcesData={setOriginalResourcesData}
            isLoading={isBackdropLoading}
            setIsLoading={setIsLoading}
            loadingManager={loadingManager}
            resource_type={"main-resource"}
            resourcePath="root"
            connectionKeysData={fetchedConnectionKeys}
          />

          <RunParameters
            runParameters={runParameters}
            setRunParameters={setRunParameters}
            isEditResource={isEditResource}
            setIsEditResource={setIsEditResource}
            setIsLoading={setIsLoading}
            severityColumnNames={severityColumnNames}
            setSeverityColumnNames={setSeverityColumnNames}
            isReRun={isReRunData?.isReRun}
            expandedAccordion={expandedAccordion}
            handleChangeAccordion={handleChangeAccordion}
            feature="validateResource"
          />

          <ScoringConfigOverrideAccordion
            type="validation"
            generateScore={!!runParameters?.generate_score}
            currentConfig={validationScoringConfig}
            expanded={expandedAccordion === "scoring-config-overrides"}
            onChange={handleChangeAccordion("scoring-config-overrides")}
            onOverrideChange={setScoreConfigOverride}
            disabled={isEditResource}
          />

          <Accordion
            className="mt-8 heading-bold box-shadow color-palette color-palette-1"
            expanded={expandedAccordion === "result-storage-parameters"}
            onChange={handleChangeAccordion("result-storage-parameters")}
          >
            <AccordionSummary
              aria-controls="panel1d-content"
              id="panel1d-header"
              expandIcon={<ExpandMoreIcon />}
            >
              Result Storage Parameters
            </AccordionSummary>
            <AccordionDetails sx={{ paddingTop: "16px" }}>
              <ResultStorageParameters
                resultStorageParameters={resultStorageParameters}
                setResultStorageParameters={setResultStorageParameters}
                isEditResource={isEditResource}
                setIsEditResource={setIsEditResource}
                setIsLoading={setIsLoading}
                isFromRule={false}
                isReRun={isReRunData?.isReRun}
              />
            </AccordionDetails>
          </Accordion>

          {validateResourceVariable.allVariables &&
            Object.keys(validateResourceVariable.allVariables).length > 0 && (
              <Accordion
                className="mt-8 heading-bold box-shadow color-palette color-palette-1"
                expanded={expandedAccordion === "inline-variables"}
                onChange={handleChangeAccordion("inline-variables")}
              >
                <AccordionSummary
                  aria-controls="panel1d-content"
                  id="panel1d-header"
                  expandIcon={<ExpandMoreIcon />}
                >
                  Resource Variables
                </AccordionSummary>
                <AccordionDetails sx={{ paddingTop: "16px" }}>
                  <div className="text-box-card box-card-variables full-radius">
                    {!validateResourceVariable.isEditing ? (
                      <div className="inline-variables-parent">
                        <InlineVariables
                          inlineVariables={{
                            inline_variables: getFilteredVariables(),
                            used_variables:
                              validateResourceVariable.usedVariableNames,
                          }}
                          handleChangeVariable={handleChangeVariable}
                          isReadOnly={true}
                          isDisplayUsedVariable={true}
                          showVariables={validateResourceVariable.showVariables}
                          setShowVariables={(
                            view: React.SetStateAction<string>
                          ) => {
                            const newView =
                              typeof view === "function"
                                ? view(validateResourceVariable.showVariables)
                                : view;
                            toggleVariableView(
                              newView === "used" ? "used" : "unused"
                            );
                          }}
                        />
                      </div>
                    ) : (
                      <div className="inline-variables-parent">
                        <InlineVariables
                          inlineVariables={{
                            inline_variables: getFilteredVariables(),
                            used_variables:
                              validateResourceVariable.usedVariableNames,
                          }}
                          handleChangeVariable={handleChangeVariable}
                          isReadOnly={false}
                          isDisplayUsedVariable={true}
                          showVariables={validateResourceVariable.showVariables}
                          setShowVariables={(
                            view: React.SetStateAction<string>
                          ) => {
                            const newView =
                              typeof view === "function"
                                ? view(validateResourceVariable.showVariables)
                                : view;
                            toggleVariableView(
                              newView === "used" ? "used" : "unused"
                            );
                          }}
                        />
                      </div>
                    )}
                    {!validateResourceVariable.isEditing &&
                      hasAnyVariables() && (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md
                          sx={{
                            justifyContent: "flex-end",
                            display: "flex",
                            marginTop: "8px",
                          }}
                        >
                          <button
                            className="btn-nostyle icon-btn-edit"
                            onClick={() => {
                              startEditingVariables();
                            }}
                          >
                            <IconBtnEditBase ariaLabel="Edit variables" />
                          </button>
                        </Grid>
                      )}
                    {validateResourceVariable.isEditing && (
                      <Grid
                        item
                        xs
                        sx={{
                          display: "flex",
                          alignItems: "flex-end",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            columnGap: "8px",
                            flexWrap: "wrap",
                            marginTop: "8px",
                          }}
                        >
                          <Button
                            color="secondary"
                            variant="contained"
                            onClick={() => {
                              cancelVariableChanges();
                            }}
                            className="btn-orange btn-dark"
                          >
                            Cancel
                          </Button>
                          <Button
                            color="secondary"
                            variant="contained"
                            onClick={() => {
                              saveVariableChanges();
                            }}
                            className="btn-orange"
                            disabled={!hasVariableChanges()}
                          >
                            <SaveOutlinedIcon /> &nbsp; Save
                          </Button>
                        </Box>
                      </Grid>
                    )}
                  </div>
                </AccordionDetails>
              </Accordion>
            )}

          {resourcesData?.additional_properties?.filter_rules &&
            resourcesData?.additional_properties?.filter_rules.length > 0 && (
              <CustomAccordian
                expandId="filter-rules"
                title="Filter Rules"
                handleChangeAccordion={handleChangeAccordion}
                isEnabled={true}
                topMargin={8}
                className="color-palette color-palette-0"
              >
                <FilterRules
                  formData={
                    !isEditFilters ? filterFormData : tempFilterFormData
                  }
                  isAddButtonHidden={true}
                  setFormData={setTempFilterFormData}
                  isViewOnly={!isEditFilters}
                  resourceColumnData={resourceColumnData}
                  checkFilterRuleValidation={checkFilterRuleValidation}
                />

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md
                  sx={{
                    justifyContent: "flex-end",
                    display: "flex",
                    marginTop: "8px",
                  }}
                >
                  {!isEditFilters && (
                    <button
                      className="btn-nostyle icon-btn-edit"
                      onClick={() => {
                        setIsEditFilters((prev) => !prev);
                      }}
                    >
                      <IconBtnEditBase ariaLabel="Edit filter rules" />
                    </button>
                  )}

                  {isEditFilters && (
                    <Grid
                      item
                      xs
                      sx={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          columnGap: "8px",
                          flexWrap: "wrap",
                        }}
                      >
                        <Button
                          color="secondary"
                          variant="contained"
                          onClick={() => {
                            setIsEditFilters((prev: any) => !prev);
                            setTempFilterFormData(filterFormData);
                          }}
                          className="btn-orange btn-dark"
                        >
                          Cancel
                        </Button>
                        <Button
                          type="button"
                          onClick={() => {
                            setIsEditFilters((prev) => !prev);
                            setFilterFormData(tempFilterFormData);
                            setIntialFilterFormData(tempFilterFormData);
                          }}
                          variant="contained"
                          color="secondary"
                          className="btn-orange"
                          title="Save Resource"
                          disabled={!hasFilterChanges}
                        >
                          <SaveOutlinedIcon /> &nbsp; Save
                        </Button>
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </CustomAccordian>
            )}
          {resourceColumnData?.resource_column_properties
            ?.cross_field_validations &&
            resourceColumnData?.resource_column_properties
              ?.cross_field_validations.length > 0 && (
              <CustomAccordian
                expandId="adhoc-query"
                title="Adhoc Query"
                handleChangeAccordion={handleChangeAccordion}
                isEnabled={true}
                topMargin={8}
                className="color-palette color-palette-0"
              >
                <AddMultipleGridList
                  gridValue={
                    resourceColumnData?.resource_column_properties
                      ?.cross_field_validations
                  }
                  setGridValue={() => {}}
                  isViewOnly={true}
                  buttonName=" "
                  errors={{}}
                  setErrors={() => {}}
                />
              </CustomAccordian>
            )}
          {!isEditResource && isResourceEdit === "" && (
            <FlexBetween
              gap="1rem"
              sx={{
                marginTop: 2,
                display: "flex",
                justifyContent: "flex-end",
                gap: "1rem",
              }}
            >
              <Button
                className="btn-orange btn-dark"
                color="secondary"
                variant="contained"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0,
                  padding: "6px 16px",
                  position: "relative",
                }}
                onClick={() => {
                  const payload = buildValidationPayload();
                  setValidateResourcePayload(payload);
                  setIsPayloadDialogOpen(true);
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    paddingRight: "12px",
                  }}
                >
                  View JSON
                </Box>
                <Box
                  sx={{
                    width: "1px",
                    height: "24px",
                    backgroundColor: "rgba(255, 255, 255, 0.3)",
                    marginX: "8px",
                  }}
                />
                <Box
                  onClick={handleCopyPayload}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingLeft: "8px",
                    paddingRight: "4px",
                    cursor: "pointer",
                    "&:hover": {
                      opacity: 0.8,
                    },
                  }}
                  title="Copy JSON to clipboard"
                >
                  <ContentCopyIcon sx={{ fontSize: "18px" }} />
                </Box>
              </Button>
              <Button
                type="submit"
                className="btn-orange"
                color="secondary"
                variant="contained"
                onClick={handleValidateSubmit}
              >
                {isReRunData?.isReRun ? "Re-Validate" : "Validate"}
              </Button>
            </FlexBetween>
          )}
        </Box>
      </div>

      <ViewPayloadDialog
        openDialog={isPayloadDialogOpen}
        dialogTitle="Validation JSON"
        payload={validateResourcePayload}
        handleDialogClose={() => {
          setIsPayloadDialogOpen(false);
          setValidationResponse(null);
        }}
        onValidate={handleValidatePayload}
        isValidating={isValidating}
        validationResponse={validationResponse}
      />
    </>
  );
};

export default ValidateResource;
